import { AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { mapKeys, set } from 'lodash'

import { isBlobLike, isObjectArray, isPlainObject } from '@ahha/utils/@types/typeChecks'
import { API } from '@/api'
import { store } from '@/stores'
import { getLicenseFeaturesHeader } from '@/utils/license'

import { SuccessResponse, TransformedResponse } from './types'

export const setToken = (config: InternalAxiosRequestConfig<any>) => {
  const token = API().getToken()

  if (token) {
    set(config.headers, 'Authorization', `Bearer ${token}`)
  }

  const licenseFeatures = getLicenseFeaturesHeader()
  if (licenseFeatures) {
    set(config.headers, 'license-features', licenseFeatures)
  }

  // 현재 워크스페이스 id를 모든 요청 헤더에 실어 보냄. 서버에서 통계 쌓기 위해 필요.
  const currentWorkspaceId = store.getState().user.user.lastWorkspaceId
  if (currentWorkspaceId) {
    set(config.headers, 'X-Workspace-Id', currentWorkspaceId)
  }

  return config
}

export const removeIdUnderScore = <T extends SuccessResponse<any>>(config: AxiosResponse<T>) => {
  const { data } = config.data

  if (isPlainObject(data)) {
    const underScoreRemoved = mapKeys(data, (_, k) => (k === '_id' ? 'id' : k))

    return {
      ...config,
      data: {
        ...config.data,
        data: underScoreRemoved,
      },
    }
  }
  if (isObjectArray(data)) {
    const underScoreRemoved = data.map((d) => mapKeys(d, (_, k) => (k === '_id' ? 'id' : k)))

    return {
      ...config,
      data: {
        ...config.data,
        data: underScoreRemoved,
      },
    }
  }
  return config
}

// FIXME: axios interceptor 리스폰스 핸들링 방식 수정 필요 (현재는 너무 확장성이 고려되어 있지 않음)
export const flattenResponseData = <T extends SuccessResponse<any>>(response: AxiosResponse<T>) => {
  /**
    * response의 `data` 속성이 객체이면 해당 객체를 spread해서 반환, 배열이면 `data` 속성에 그대로 반환.
    * 속성을 추가하거나 axios config, headers, request 객체가 필요하다면
    * 아래 코드를 수정하고 {@link ./types.ts}의 `TransformedResponse` 타입도 수정할 것.
    */
  if (isPlainObject(response.data.data)) {
    return ({
      ...response.data.data,
      // status: response.status,
    }) as TransformedResponse<T>
  }

  if (isBlobLike(response.data)) {
    return response.data
  }

  return ({
    data: response.data.data,
    // status: response.status,
  }) as TransformedResponse<T>
}
